<template>
    <div class="cic-number">
        <el-input-number
            v-if="enabled"
            :model-value="value"
            :precision="precision"
            v-bind="Object.assign(JSON.parse(JSON.stringify($attrs)), { id: null })"
            @update:modelValue="(val) => $emit('input', val)"
        />
        <span v-else>{{ parseFloat(value).toFixed(precision) }}</span>
    </div>
</template>

<script>
    import { ElInputNumber } from 'element-plus';

    export default {
        name: 'CicNumber',
        components: {
            'el-input-number': ElInputNumber,
        },
        props: {
            enabled: {
                type: Boolean,
                default: true,
            },
            precision: {
                type: Number,
                default: 0,
            },
            value: {
                type: Number,
                default: null,
            },
        },
        emits: ['input'],
    };
</script>
